import { DashboardLayout } from '../components/dashboard/DashboardLayout';
import { UserProfile } from '../components/dashboard/UserProfile';
import { ApiKeyManager } from '../components/dashboard/ApiKeyManager';

export const DashboardPage = () => {
    return (
        <DashboardLayout>
            <div className="space-y-4 sm:space-y-6 animate-fade-in">
                <div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">Dashboard</h2>
                    <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 mt-1">
                        Manage your account and API configuration
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                    <UserProfile />
                    <ApiKeyManager />
                </div>
            </div>
        </DashboardLayout>
    );
};
